/* eslint-disable @typescript-eslint/no-explicit-any */
import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faCircleCheck,
  faPen,
  faTrashCan,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ContactoReadingDtoProps } from "api/DTOs/ContactoReadingDto"
import { FormaContactoReadingDtoProps } from "api/DTOs/FormaContactoReadingDto"
import { TFunction } from "i18next"
import { EtiquetasContactosBodyTemplate } from "../templates"

export const CONTACTOS_COLUMNS = (
  t: TFunction,
  handleRowDelete: (rowData: ContactoReadingDtoProps) => void,
  onRowClick: ({ data }: { data: ContactoReadingDtoProps }) => Promise<void>
) => {
  const columns = [
    {
      key: "razonSocial",
      header: `${t("contactos.table.headerRazonSocial")}`,
      field: "razonSocial",
      style: { width: "20%" },
      sortable: true,
      sortField: "EmpresaContacto.RazonSocial",
    },
    {
      key: "nif",
      header: `${t("contactos.table.headerNif")}`,
      field: "nif",
      style: { width: "10%" },
      sortable: true,
      sortField: "EmpresaContacto.Nif",
    },
    {
      key: "direccion",
      header: `${t("contactos.table.headerDirection")}`,
      field: "direccion",
      style: { width: "20%" },
      body: ({ direccion }: ContactoReadingDtoProps) => direccion?.calle,
    },
    {
      key: "telefonos",
      header: `${t("contactos.table.headerTelefono")}`,
      field: "telefonos",
      style: { width: "10%" },
      body: ({ telefonos }: ContactoReadingDtoProps) =>
        telefonos?.find(
          (telefono: FormaContactoReadingDtoProps) => telefono.principal
        )?.contacto ?? telefonos?.[0]?.contacto,
    },
    {
      key: "emails",
      header: `${t("contactos.table.headerEmail")}`,
      field: "emails",
      style: { width: "10%" },
      body: ({ emails }: ContactoReadingDtoProps) =>
        emails?.find((email: FormaContactoReadingDtoProps) => email.principal)
          ?.contacto ?? emails?.[0]?.contacto,
    },
    {
      key: "etiquetas",
      header: `${t("contactos.table.headerLabels")}`,
      field: "etiquetas",
      style: { width: "20%" },
      body: ({ etiquetas }: ContactoReadingDtoProps) =>
        EtiquetasContactosBodyTemplate({ etiquetas }),
    },
    {
      key: "cuentasBancarias",
      header: `${t("contactos.table.headerBankAccount")}`,
      field: "cuentasBancarias",
      style: { width: "5%" },
      body: ({ cuentasBancarias }: ContactoReadingDtoProps) => {
        return cuentasBancarias?.length ? (
          <FontAwesomeIcon
            icon={faCircleCheck}
            className='tw-block tw-text-secondary tw-w-6 tw-h-6 !tw-mx-auto'
          />
        ) : null
      },
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end !tw-h-full",
      alignCol: "right",
      body: (rowData: ContactoReadingDtoProps) => {
        if (!rowData.id) return null
        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: `${t("contactos.table.editContact")}`,
                hasRedirect: true,
                action: () => onRowClick({ data: rowData }),
                icon: faPen,
              },
              {
                title: `${t("contactos.table.deleteContact")}`,
                hasRedirect: true,
                action: () => handleRowDelete(rowData),
                icon: faTrashCan,
                className: "tw-text-danger",
              },
            ]}
            position='right'
          />
        )
      },
    },
  ]
  return columns
}
